module.exports = __webpack_public_path__ + "img/AT0000001220928.170ba431.svg";